import { useQuery } from "@tanstack/react-query";
import { useLanguage } from "../context/LanguageContext";
import { publicBlogPostsQueryOptions } from "../lib/publicContentQueries";

export const usePublicBlogPosts = (options = {}) => {
  const { language } = useLanguage();

  return useQuery(publicBlogPostsQueryOptions(language, options));
};
